<template>
  <div class="content_top">
    <div>{{title}}</div>
<!--    <div class="ball">-->
<!--      <div></div>-->
<!--      <div></div>-->
<!--    </div>-->
  </div>
</template>



<script>
export default {
  name: "content_top",
  props:['title'],
}
</script>



<style scoped lang="scss">
.content_top {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 18px;
  color: #001A33;
  //line-height: 28px;
  text-align: left;
  font-style: normal;
  margin-bottom: 10px;

}

.ball {
  display: flex;
}
.ball div:nth-child(1) {
  margin-left: 5px;
  width: 12px;
  height: 12px;
  background: #E62344;
  border-radius: 50%;
}

.ball div:nth-child(2) {
  margin-left: -2px;
  width: 12px;
  height: 12px;
  background: #004190;
  border-radius: 50%;
}


@media only screen and (max-width: 767px) {

.content_top{
  font-weight: 500;
  font-size: 0.31rem;
  color: #004190;
  line-height: 0.42rem;
  text-align: left;
  font-style: normal;
  margin-bottom: 0.15rem;

  .ball div:nth-child(1) {
    margin-left: 0.1rem;
    width: 0.19rem;
    height: 0.19rem;
    background: #E62344;
    border-radius: 50%;
  }

  .ball div:nth-child(2) {
    margin-left: -2px;
    width: 0.19rem;
    height: 0.19rem;
    background: #004190;
    border-radius: 50%;
  }

}


}

</style>